import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Submenu-item element, used for each individual submenu-item within the submenu element
 *
 * @prop {String} link - Used to define the link of the submenuitem
 * @prop {String} label - Used to define the submenu-item text
 * @prop {String} active - Used to display the active submenu-item (bold text)
 * @prop {String} icon - optional, used to define a Fontawesome icon
 *
 */
let SDBNavSubMenuItem = class SDBNavSubMenuItem extends LitElement {
    constructor() {
        super(...arguments);
        this.link = '';
        this.active = false;
        this.icon = '';
        this.label = '';
    }
    render() {
        return html `
            ${this.link && this.link.length
            ? html ` <div>
                      <a href="${this.link}">
                          ${this.icon && this.icon.length
                ? html `<sdb-content-icon
                                    size="20"
                                    .icon=${this.icon}
                                ></sdb-content-icon>`
                : html ``}
                          ${this.label}
                      </a>
                      <div></div>
                  </div>`
            : html ` <div>
                      ${this.icon && this.icon.length
                ? html `<sdb-content-icon
                                size="20"
                                .icon=${this.icon}
                            ></sdb-content-icon>`
                : html ``}
                      ${this.label}
                  </div>`}
        `;
    }
};
SDBNavSubMenuItem.styles = [
    elements,
    css `
            :host div {
                display: block;
                width: fit-content;
                height: 40px;
                padding-right: 30px;
                line-height: 40px;
                color: var(--text-primary);
                text-align: left;
                text-decoration: none;
                background: var(--element-lightgrey);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                cursor: pointer;
            }

            :host a {
                text-decoration: none;
                display: block;
                color: var(--text-primary);
            }

            :host([active]) div a {
                color: var(--text-light);
            }

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */

                :host {
                    display: flex;
                    justify-self: stretch;
                }

                :host div {
                    width: 100%;
                }
            }

            :host div sdb-content-icon {
                margin-left: 15px;
                margin-right: 10px;
                display: inline-flex;
                vertical-align: middle;
                margin-top: -5px;
                color: var(--theme-primary);
            }

            :host div:hover {
                background: var(--element-grey);
            }

            :host([active]) div,
            :host([active]) div:hover {
                background: var(--theme-primary);
                color: var(--text-light);
            }

            :host([active]) div sdb-content-icon {
                color: var(--text-light);
            }
        `,
];
__decorate([
    property({ type: String })
], SDBNavSubMenuItem.prototype, "link", void 0);
__decorate([
    property({ type: Boolean })
], SDBNavSubMenuItem.prototype, "active", void 0);
__decorate([
    property({ type: String })
], SDBNavSubMenuItem.prototype, "icon", void 0);
__decorate([
    property({ type: String })
], SDBNavSubMenuItem.prototype, "label", void 0);
SDBNavSubMenuItem = __decorate([
    customElement('sdb-nav-submenu-item')
], SDBNavSubMenuItem);
export { SDBNavSubMenuItem };
//# sourceMappingURL=sdb-nav-submenu-item.js.map